import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
/**
 * @author rkassmullet
 */
export let AbBooleanLogicTreeFocus;
(function (_AbBooleanLogicTreeFocus) {
  const SOURCETYPE = _AbBooleanLogicTreeFocus.SOURCETYPE = "source";
  const ARGTYPE = _AbBooleanLogicTreeFocus.ARGTYPE = "argument";
  const ROWTYPE = _AbBooleanLogicTreeFocus.ROWTYPE = "row";
  class SourceTarget {
    constructor(key) {
      _defineProperty(this, "type", SOURCETYPE);
      _defineProperty(this, "_key", void 0);
      this._key = key;
    }
    get key() {
      return this._key;
    }
  }
  _AbBooleanLogicTreeFocus.SourceTarget = SourceTarget;
  class ArgTarget {
    constructor(rowKey, argName) {
      _defineProperty(this, "type", ARGTYPE);
      _defineProperty(this, "_key", void 0);
      _defineProperty(this, "_argName", void 0);
      this._key = rowKey;
      this._argName = argName;
    }
    get key() {
      return this._key;
    }
    get argName() {
      return this._argName;
    }
  }
  _AbBooleanLogicTreeFocus.ArgTarget = ArgTarget;
  class RowTarget {
    constructor(key) {
      _defineProperty(this, "type", ROWTYPE);
      _defineProperty(this, "_key", void 0);
      this._key = key;
    }
    get key() {
      return this._key;
    }
  }
  _AbBooleanLogicTreeFocus.RowTarget = RowTarget;
})(AbBooleanLogicTreeFocus || (AbBooleanLogicTreeFocus = {}));
//# sourceMappingURL=AbBooleanLogicTreeFocus.js.map
